import React, { useState, useEffect } from 'react';

import { Divider, Form } from 'antd';
import { NotificationInstance } from 'antd/es/notification/interface';

import IBaseComponentProps from '@components/base-component-props';

import { exception } from '@extensions/notification';
import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

interface IPreloadingCountryTotal {
    countryName: string;
    qty: number;
    cities: Array<IPreloadingCityTotal>;
}

interface IPreloadingCityTotal {
    cityName: string;
    qty: number;
}

interface IPreloadingTotalsProps extends IBaseComponentProps {
    api: NotificationInstance;
}

const PreloadingTotals = (props: IPreloadingTotalsProps) => {
    const { api, serverFetch } = props;

    const d = useAppDispatch();

    const [totals, setTotals] = useState<Array<IPreloadingCountryTotal>>([]);

    const [refreshRequired, setRefreshRequired] = useState<boolean>(true);

    useEffect(() => {
        if (!refreshRequired) return;

        setRefreshRequired(false);

        serverFetch(`preloading/totals`, { method: 'GET' })
            .then((data: Array<IPreloadingCountryTotal>) => {
                setTotals(data);
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка получения итогового груза', ex, () => d(userLoaded(undefined)));
            });
    }, [refreshRequired]);

    return (
        <>
            {totals.map((t) => {
                return (
                    <div key={t.countryName} style={{ marginBottom: 40 }}>
                        <Divider size='small' titlePlacement='left' style={{ marginTop: 0, fontSize: 20 }}>
                            {t.countryName} - {t.qty}
                        </Divider>
                        {t.cities.map((c) => {
                            return (
                                <div key={c.cityName}>
                                    <Form colon={false} labelCol={{ span: 16 }} wrapperCol={{ span: 8 }} labelAlign='left'>
                                        <Form.Item label={<span style={{ fontSize: 18 }}>{c.cityName}</span>}>
                                            <span style={{ fontSize: 18, fontWeight: 600 }}>{c.qty} </span>
                                        </Form.Item>
                                    </Form>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </>
    );
};

export default PreloadingTotals;
